var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryGames32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Games_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Games_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-12",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Games_32",
    transform: "translate(10.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.014,5.999 L3.013,5.999 L3.013,4.999 L5.014,4.999 L5.014,2.998 L6.014,2.998 L6.014,4.999 L8.015,4.999 L8.015,5.999 L6.014,5.999 L6.014,8 L5.014,8 L5.014,5.999 Z M23.515,7.501 C24.067,7.501 24.515,7.053 24.515,6.501 C24.515,5.95 24.067,5.501 23.515,5.501 C22.963,5.501 22.515,5.95 22.515,6.501 C22.515,7.053 22.963,7.501 23.515,7.501 L23.515,7.501 Z M21.513,5.5 C22.065,5.5 22.513,5.051 22.513,4.5 C22.513,3.949 22.065,3.5 21.513,3.5 C20.961,3.5 20.513,3.949 20.513,4.5 C20.513,5.051 20.961,5.5 21.513,5.5 L21.513,5.5 Z M27.014,15.346 C27.01,15.621 26.906,18.034 24.557,18.034 C22.668,18.034 21.154,13.966 20.047,10.995 C19.955,10.746 19.863,10.501 19.773,10.262 C20.581,10.729 21.516,11 22.514,11 C24.374,11 26.018,10.07 27.014,8.653 L27.014,15.346 Z M9.825,9 C9.867,8.907 9.909,8.806 9.95,8.72 C10.608,7.814 11,6.703 11,5.5 C11,4.172 10.526,2.952 9.739,2 L18.275,2 C17.488,2.952 17.014,4.172 17.014,5.5 C17.014,6.703 17.407,7.814 18.064,8.72 C18.105,8.806 18.147,8.907 18.189,9 L9.825,9 Z M3.457,18.034 C1.109,18.034 1.004,15.621 1,15.352 L1,8.653 C1.996,10.07 3.641,11 5.5,11 C6.499,11 7.433,10.729 8.241,10.262 C8.151,10.501 8.06,10.746 7.967,10.995 C6.861,13.966 5.346,18.034 3.457,18.034 L3.457,18.034 Z M5.5,1 C7.982,1 10,3.019 10,5.5 C10,7.982 7.982,10 5.5,10 C3.019,10 1,7.982 1,5.5 C1,3.019 3.019,1 5.5,1 L5.5,1 Z M27.014,5.5 C27.014,7.982 24.995,10 22.514,10 C20.033,10 18.014,7.982 18.014,5.5 C18.014,3.019 20.033,1 22.514,1 C24.995,1 27.014,3.019 27.014,5.5 L27.014,5.5 Z M28.014,5.5 C28.014,2.468 25.546,0 22.514,0 C21.342,0 20.256,0.372 19.363,1 L8.652,1 C7.758,0.372 6.673,0 5.5,0 C2.468,0 0,2.468 0,5.5 C0,5.56 0.007,5.618 0.009,5.677 L0,5.677 L0,15.356 C0.012,16.628 0.749,19.034 3.457,19.034 C6.04,19.034 7.628,14.77 8.904,11.344 C9.078,10.876 9.247,10.423 9.412,10 L18.603,10 C18.767,10.423 18.936,10.876 19.111,11.344 C20.386,14.77 21.974,19.034 24.557,19.034 C27.265,19.034 28.002,16.628 28.014,15.352 L28.014,5.677 L28.005,5.677 C28.007,5.618 28.014,5.56 28.014,5.5 L28.014,5.5 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryGames32);
export default __webpack_public_path__ + "static/media/Arch-Category_Games_32.6772ba32a7aa360a93068329e478d23b.svg";
export { ForwardRef as ReactComponent };